// rrd import
import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import FooterCopyright from "../components/FooterCopyright";
// Components
import Footer from "../components/Footer";
import MissionVision from "../components/MissionVision";
import Testimonials from "../components/Testimonials";
import WhySchool from "../components/WhySchool";

import "./home.css";
import img1 from "../assets/image1.webp";
import img8 from "../assets/image8.webp";
import img17 from "../assets/image17.webp";

const Home = () => {
    const images = [img1, img8, img17];
    const [current, setCurrent] = useState(0);

    useEffect(() => {
        const id = setInterval(() => setCurrent((c) => (c + 1) % images.length), 4200);
        return () => clearInterval(id);
    }, [images.length]);
    return ( 
        <>
            <div className="home">
                {images.map((img, i) => (
                    <div
                        key={i}
                        className={`bg-layer ${i === current ? "active" : ""}`}
                        style={{ backgroundImage: `url(${img})` }}
                    />
                ))}

                <div className="home-content">
                  <p className="title">Welcome to Little Sanctum</p>
                  <p className="info">Rooted in the Montessori philosophy, our preschool offers a nurturing environment where your child can grow socially, emotionally, and intellectually—at their own unique pace. We’re not just a school—we’re a supportive community that values partnership with families as we guide children on their journey of discovery, independence, and joy in learning.
We invite you to explore our programs, meet our dedicated educators, and see how Montessori can make a lasting difference in your child early years.</p>
                  <NavLink to='/about' className="explore-btn">Explore</NavLink>
                </div>
                                <div className="hero-dots" aria-hidden={false}>
                                    {images.map((_, i) => (
                                        <button
                                            key={i}
                                            className={`hero-dot ${i === current ? 'active' : ''}`}
                                            onClick={() => setCurrent(i)}
                                            aria-label={`Go to image ${i + 1}`}
                                        />
                                    ))}
                                </div>
            </div>
            <MissionVision />
            <WhySchool />
            <Testimonials />
            <Footer />
            <FooterCopyright />
            
            
        </>
    );
}
 
export default Home;